import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormSelect from "core/gd-form/form-element/select-new/select-new"

export default function CustomFieldFormat(props) {

    const formatTypeOptions = [
        { label: "Number",      value: 'number' },
        { label: "Currency",    value: 'currency' },
        { label: "Percentage",  value: 'percentage' },
    ]

    return (
        <FormRowFlex label="Format">
            <FormSelect form={props.form}
                        name="formatType"
                        options={formatTypeOptions}/>
            <FormError form={props.form} name="formatType" />
        </FormRowFlex>
    );
}

CustomFieldFormat.propTypes = {
    form: PropTypes.object
}